import { Story } from '../../DocTypes';

export const dataDrivenEnabledButtonStory: Story = {
  title: 'Data driven enabled button',
  description: 'List with items having buttons that are enabled / disabled by data',
  coreComponent: {
    html: `<tag-list
    avatar-src-field='image'
    avatar-placeholder-field='placeholder'
    avatar-size='40px'
    primary-field='name'
    secondary-field='description'
    button-1-icon='Edit'
    button-1-rounded
    button-1-disabled-field='disableEdit'>
  </tag-list>`,
    js: `var tagList = document.querySelector('tag-list');
  tagList.componentOnReady().then(function() {
    tagList.setData([
      {
        image:
          'https://images.pexels.com/photos/220453/pexels-photo-220453.jpeg?auto=compress&cs=tinysrgb&h=750&w=1260',
        name: 'Jordan Norry',
        placeholder: 'JN',
        disableEdit: true,
        description: 'Button should be disabled',
      },
      {
        image: '',
        name: 'Sarah Young',
        placeholder: 'SY',
        disableEdit: false,
        description: 'Button should be enabled',
      },
      {
        image:
          'https://images.pexels.com/photos/324658/pexels-photo-324658.jpeg?auto=compress&cs=tinysrgb&h=350',
        name: 'Susan Warmly',
        placeholder: 'SW',
        disableEdit: true,
        description: 'Button should be disabled',
      }
    ]);
  });
  `,
  },
  reactWrapper: {
    jsx: `<TagList
    avatarSrcField='image'
    avatarPlaceholderField='placeholder'
    avatarSize='40px'
    primaryField='name'
    secondaryField='description'
    button1Icon='Edit'
    button1Rounded
    button1DisabledField='disableEdit'
    data={[
      {
        image:
          'https://images.pexels.com/photos/220453/pexels-photo-220453.jpeg?auto=compress&cs=tinysrgb&h=750&w=1260',
        name: 'Jordan Norry',
        placeholder: 'JN',
        disableEdit: true,
        description: 'Button should be disabled',
      },
      {
        image: '',
        name: 'Sarah Young',
        placeholder: 'SY',
        disableEdit: false,
        description: 'Button should be enabled',
      },
      {
        image:
          'https://images.pexels.com/photos/324658/pexels-photo-324658.jpeg?auto=compress&cs=tinysrgb&h=350',
        name: 'Susan Warmly',
        placeholder: 'SW',
        disableEdit: true,
        description: 'Button should be disabled',
      }
    ]}
  />`,
  },
};
